import AOS from 'aos'

export default class Animations {
    constructor() {
        this.bindUIActions();
    }
    bindUIActions() {
        AOS.init({
            duration: 2000
        });

        // Add fade in animation to hero block as AOS doesn't work on them being already visible on page load
        const $hero = $('.js-hero-banner');

        if($hero) {
            $hero.hide();
            $hero.fadeIn(2000);
        }

    }
};
new Animations();